import Vue from 'vue'
import Vuex from 'vuex'

import ibps from './modules/ibps'
import report from './modules/report'
import getters from './getters'
Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    ibps,
    report
  },
  getters,
  state: {
    isDeBug: process.env.NODE_ENV === 'development',
    isMsg: '0',
    headerLayout: true,
    layoutHash: {
      noneHeader: {
        key: 'headerLayout',
        value: false
      }
    }
  },
  actions: {
    setIsMsg: ({ state }, val) => {
      state.isMsg = val
    },
    setLayout: ({ state }, layout) => {
      const list = layout.split(',')
      for (const item of list) {
        const l = state.layoutHash[item]
        if (l) {
          state[l.key] = l.value
        }
      }
    }
  }
})
